<template>
  <div class="os_container">
    <div class="bo_title mb-6" v-text="$t('utils.general')" />
    <div class="space__client_container">
      <!-- logo organization  -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div class="text" v-text="$t('organization.logo')" />
          <BaseParagraph
            color="primary"
            v-text="activeOrganization.logo ? 'logo' : ''"
          />
        </template>
        <template #right_items>
          <BaseButton
            type="primary"
            small
            icon="$mdiPencilOutline"
            class="ml-auto"
            @click.prevent="openModal('logo')"
          >
            {{ $t("utils.edit") }}
          </BaseButton>
        </template>
      </ClientSpaceItems>
      <!-- organization description -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div class="text" v-text="$t('organization.description')" />
          <BaseMarkdownViewer
            :content="truncateDescription(activeOrganization.description)"
            is-text-caption
          />
        </template>
        <template #right_items>
          <BaseButton
            type="primary"
            small
            icon="$mdiPencilOutline"
            class="ml-auto"
            @click.prevent="openModal('description')"
          >
            {{ $t("utils.edit") }}
          </BaseButton>
        </template>
      </ClientSpaceItems>
      <!-- organization location -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div class="text" v-text="$t('organization.location')" />
          <BaseMarkdownViewer
            :content="truncateDescription(activeOrganization.contact)"
            is-text-caption
          />
        </template>
        <template #right_items>
          <BaseButton
            type="primary"
            small
            icon="$mdiPencilOutline"
            class="ml-auto"
            @click.prevent="openModal('location')"
          >
            {{ $t("utils.edit") }}
          </BaseButton>
        </template>
      </ClientSpaceItems>
      <!-- organization cosmoform -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div
            class="text"
            v-text="$t('organization.defaultMessageCosmoform')"
          />
          <BaseMarkdownViewer
            :content="
              truncateDescription(activeOrganization.cosmoformDefaultMessage)
            "
            is-text-caption
          />
        </template>
        <template #right_items>
          <BaseButton
            type="primary"
            small
            icon="$mdiPencilOutline"
            class="ml-auto"
            @click.prevent="openModal('cosmoform')"
          >
            {{ $t("utils.edit") }}
          </BaseButton>
        </template>
      </ClientSpaceItems>

      <!-- organization lifetime notification -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div class="text" v-text="$t('organization.lifetime_notification')" />
          <BaseParagraph
            color="primary"
            v-text="activeOrganization.notificationLifetime"
          />
        </template>
        <template #right_items>
          <div class="d-flex align-items-center">
            <BaseButton
              type="primary"
              small
              icon="$mdiPencilOutline"
              class="mr-2"
              @click.prevent="openModal('lifetime_notification')"
            >
              {{ $t("utils.edit") }}
            </BaseButton>
            <BaseButton
              v-if="activeOrganization.notificationLifetime"
              type="secondary"
              color="secondary"
              small
              icon="$mdiDelete"
              class="ml-auto"
              :loading="isResettingLifetimeNotification"
              @click.prevent="resetLifetimeNotification"
            >
              {{ $t("utils.delete") }}
            </BaseButton>
          </div>
        </template>
      </ClientSpaceItems>
      <!-- organization wizidee -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div class="text" v-text="$t('organization.wizideeConfiguration')" />
          <BaseParagraph
            color="primary"
            v-text="activeOrganization.wizideeLogin"
          />
        </template>
        <template #right_items>
          <div class="d-flex align-items-center">
            <BaseButton
              type="primary"
              small
              icon="$mdiCheck"
              class="mr-2"
              :loading="isTestingWizidee"
              @click.prevent="verifyWizideeCredential"
            >
              {{ $t("organization.test_wizidee_connection") }}
            </BaseButton>
            <BaseButton
              type="primary"
              small
              icon="$mdiPencilOutline"
              class="mr-2"
              @click.prevent="openModal('wizidee')"
            >
              {{ $t("utils.edit") }}
            </BaseButton>
            <BaseButton
              type="secondary"
              color="secondary"
              small
              icon="$mdiDelete"
              class="ml-auto"
              :loading="isDeleting"
              @click.prevent="deleteWizideeConfig"
            >
              {{ $t("utils.delete") }}
            </BaseButton>
          </div>
        </template>
      </ClientSpaceItems>

      <!-- organization yousign -->
      <ClientSpaceItems class="mb-5">
        <template #left_items>
          <div class="text" v-text="$t('organization.yousignConfiguration')" />
          <BaseParagraph
            color="primary"
            v-text="activeOrganization.yousignWebhookUrl"
          />
        </template>
        <template #right_items>
          <div class="d-flex align-items-center">
            <BaseButton
              type="primary"
              small
              icon="$mdiCheck"
              class="mr-2"
              :loading="isTestingYousign"
              @click.prevent="verifyYousignCredential"
            >
              {{ $t("organization.test_yousign_connection") }}
            </BaseButton>
            <BaseButton
              type="primary"
              small
              icon="$mdiPencilOutline"
              class="mr-2"
              @click.prevent="openModal('yousign')"
            >
              {{ $t("utils.edit") }}
            </BaseButton>
            <BaseButton
              type="secondary"
              color="secondary"
              small
              icon="$mdiDelete"
              class="ml-auto"
              :loading="isDeletingYousign"
              @click.prevent="deleteYousignConfig"
            >
              {{ $t("utils.delete") }}
            </BaseButton>
          </div>
        </template>
      </ClientSpaceItems>
      <!-- organization services  -->
      <ClientSpaceItems>
        <template #left_items>
          <div class="text" v-text="$t('organization.services')" />
          <div
            v-for="(service, index) in organizationCampaignsServices"
            :key="service.id + index"
            class="d-flex align-center my-2"
          >
            <BaseParagraph color="primary" v-text="service.name" />
            <BaseButton
              type="primary"
              small
              icon="$mdiClose"
              class="ml-auto"
              @click="deleteCampaignFromCustomerServices(service)"
            >
              {{ $t("utils.delete") }}
            </BaseButton>
          </div>
        </template>
      </ClientSpaceItems>
    </div>
    <!-- MAIL EXPORT SECTION -->
    <OrganizationMailExport />
    <AvatarEdition />
    <OrganizationInformationEditDialog />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ClientSpaceItems from "@/modules/Admin/Components/ClientSpaceItems.vue";
import OrganizationInformationEditDialog from "@/modules/Admin/Components/OrganizationInformationEditDialog.vue";
import AvatarEdition from "@/modules/Admin/Components/AvatarEdition.vue";
import {
  postOrganizationWizideeVerification,
  postOrganizationYousignVerification,
} from "@/core/Services/organization.service";
import OrganizationMailExport from "@/modules/Admin/Components/OrganizationMailExport.vue";
export default {
  name: "OrganizationSettings",
  components: {
    ClientSpaceItems,
    OrganizationInformationEditDialog,
    AvatarEdition,
    OrganizationMailExport,
  },
  data() {
    return {
      isTestingWizidee: false,
      isDeleting: false,
      isTestingYousign: false,
      isDeletingYousign: false,
      isResettingLifetimeNotification: false,
    };
  },
  computed: {
    ...mapState({
      activeOrganization: (state) => state.organization.activeOrganization,
      organizationCampaignsServices: (state) =>
        state.course.organizationCampaignsServices,
    }),
  },
  created() {
    this.initialize();
  },
  methods: {
    truncateDescription(description) {
      return description.length > 200
        ? description.substring(0, 175) + "..."
        : description;
    },
    async deleteCampaignFromCustomerServices(campaign) {
      const payload = { published: false };
      try {
        await this.$store.dispatch("course/updateOrganizationCourseCampaign", {
          organizationId: this.$route.params.organizationId,
          campaignId: campaign.id,
          payload,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("campaign.deletedSuccessFullyFromClientSpace"),
          type: "SUCCESS",
        });

        // filter locally campaign services
        this.$store.commit(
          "course/setCampaignServices",
          this.organizationCampaignsServices.filter(
            (service) => service.id !== campaign.id
          )
        );
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("campaign.errorDeletingFromClientSpace"),
          type: "ERROR",
        });
      }
    },
    async initialize() {
      if (!this.$route.params.organizationId) return;
      await this.$store.dispatch("course/getOrganizationCampaignsServices", {
        organizationId: this.$route.params.organizationId,
      });
    },
    async verifyWizideeCredential() {
      this.isTestingWizidee = true;
      try {
        await postOrganizationWizideeVerification({
          organizationId: this.$route.params.organizationId,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("organization.connected_successfully_to_wizidee"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("organization.connection_error_to_wizidee"),
          type: "ERROR",
        });
      }
      this.isTestingWizidee = false;
    },

    async verifyYousignCredential() {
      this.isTestingYousign = true;
      try {
        await postOrganizationYousignVerification({
          organizationId: this.$route.params.organizationId,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("organization.connected_successfully_to_yousign"),
          type: "SUCCESS",
        });
      } catch (error) {
        let msg = this.$t("organization.missing_credentials");
        if (error?.response?.data?.code) {
          switch (error?.response?.data?.code) {
            case "invalid-yousign-api-key":
              msg = this.$t("organization.invalidApiKeyYousign");
              break;
            case "invalid-yousign-workspace-id":
              msg = this.$t("organization.invalid_yousign_workspace_id");
              break;
            default:
              break;
          }
        }
        this.$store.dispatch("snackbar/active", {
          message: msg,
          type: "ERROR",
        });
      }
      this.isTestingYousign = false;
    },
    async resetLifetimeNotification() {
      const payload = { notification_lifetime: null };
      this.isResettingLifetimeNotification = true;
      try {
        const response = await this.$store.dispatch(
          "organization/patchOrganization",
          {
            organizationId: this.$route.params.organizationId,
            payload,
          }
        );
        this.$store.commit("organization/setUpdateSpecificOrganization", {
          payload: response,
          organizationId: this.$route.params.organizationId,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.deleteSuccess"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.editError"),
          type: "ERROR",
        });
      }
      this.isResettingLifetimeNotification = false;
    },
    async deleteYousignConfig() {
      const payload = { yousign_api_key: "", yousign_workspace_id: "" };
      this.isDeletingYousign = true;
      try {
        const response = await this.$store.dispatch(
          "organization/patchOrganization",
          {
            organizationId: this.$route.params.organizationId,
            payload,
          }
        );
        this.$store.commit("organization/setUpdateSpecificOrganization", {
          payload: response,
          organizationId: this.$route.params.organizationId,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.deleteSuccess"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.editError"),
          type: "ERROR",
        });
      }
      this.isDeletingYousign = false;
    },
    async deleteWizideeConfig() {
      const payload = { wizidee_login: "", wizidee_password: "" };
      this.isDeleting = true;
      try {
        const response = await this.$store.dispatch(
          "organization/patchOrganization",
          {
            organizationId: this.$route.params.organizationId,
            payload,
          }
        );
        this.$store.commit("organization/setUpdateSpecificOrganization", {
          payload: response,
          organizationId: this.$route.params.organizationId,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.deleteSuccess"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.editError"),
          type: "ERROR",
        });
      }
      this.isDeleting = false;
    },
    openModal(type) {
      this.$store.commit(
        "organization/setIsOrganizationEditInformationModalOpen",
        { status: true, type }
      );
    },
  },
};
</script>
<style scoped>
.space__client_container {
  padding: 24px;
  background: #fff;
}
</style>
